import config from "config";
import tools from "tools";
import assets from ".";
class LocaleManager {
  constructor() {
    tools.autobind(this);
    this._words = {};
    this._wordMax = 0;
    this._wordLoaded = 0;
  }
  init(callback) {
    this._callback = callback;
    // Détection de la langue : config.locale, puis navigateur, puis "en"
    const navLang = typeof navigator !== "undefined" && navigator.language ? navigator.language.slice(0, 2).toLowerCase() : "en";
    this._currentLang = (config.locale || navLang || "en").toLowerCase();
    // Si on a des locales chargées et la langue demandée, utiliser la traduction locale en priorité
    this._localeObj = assets.locales && assets.locales[this._currentLang] ? assets.locales[this._currentLang] : null;
    for (const key in assets.localeBase) {
      this._wordMax++;
      this.translate(key);
    }
  }
  translate(key) {
    config.sdk.getI18nModule().getTranslation(key).then(value => {
      // Si le SDK renvoie une vraie traduction, l'utiliser ; sinon fallback sur les locales chargées (assets.locales) ou en.json
      const fromSdk = value != null && value !== "" && value !== key;
      const fromLocale = !fromSdk && this._localeObj && this._localeObj[key];
      const fromBase = !fromSdk && !fromLocale && assets.localeBase && assets.localeBase[key];
      this._words[key] = fromSdk ? value : fromLocale ? this._localeObj[key] : fromBase ? assets.localeBase[key] : key;
      this._wordLoaded++;
      if (this._wordLoaded >= this._wordMax) {
        this._callback();
      }
    });
  }
  get words() {
    return this._words;
  }
  get currentLang() {
    return this._currentLang || "en";
  }
}
export default new LocaleManager();
